<template>
  <span>
    <v-card style="width: 100%" flat>
      <v-skeleton-loader type="table" v-if="loading"></v-skeleton-loader>
      <v-data-table
        v-else-if="batches && batches.data"
        :headers="headers"
        :items="batches.data"
        :loading="loading"
        no-data-text="No batches found"
        fixed-header
        hide-default-footer
        :items-per-page="50"
        height="80vh"
      >
        <template v-slot:item.batch_number="{ item }">
          <v-btn
            @click="openDetailsDialog(item)"
            text
            color="orange"
            class="pa-0"
            small
            >{{ item.batch_number }}</v-btn
          > </template
        >.

        <template v-slot:item.item.id="{ item }">
          <v-btn
            text
            color="orange"
            class="pa-0"
            target="_blank"
            :to="'/inventory/view/' + item.item_id"
            small
            >{{ item.item.name }}
            <sup
              ><v-icon color="orange" x-small>mdi-open-in-new</v-icon></sup
            ></v-btn
          >
        </template>

        <template v-slot:item.expiry_date="{ item }">
          <span v-if="item.expiry_date">
            {{ item.expiry_date | humanDate }}
          </span>
          <span v-else> N/A </span>
        </template>
        <template v-slot:item.quantity="{ item }">
          {{ item.quantity_used }} / {{ item.quantity }}
        </template>

        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | humanDateTime }}
        </template>

        <template v-slot:item.updated_at="{ item }">
          {{ item.updated_at | humanDateTime }}
        </template>

        <template v-slot:item.status="{ item }">
          <v-avatar :color="get_expiry_status(item).bgColor" size="25">
            <v-icon small :color="get_expiry_status(item).color">{{
              get_expiry_status(item).icon
            }}</v-icon>
          </v-avatar>
          <span :class="get_expiry_status(item).textColor">
            {{ get_expiry_status(item).text }}
          </span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="openDetailsDialog(item)">
                <v-list-item-content>
                  <v-list-item-title style="cursor: pointer">
                    View Details
                  </v-list-item-title>
                </v-list-item-content>
                <!-- <v-list-item-title>View Details</v-list-item-title> -->
              </v-list-item>
              <v-list-item @click="openUpdateDialog(item)">
                <v-list-item-title>Update Batch</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDeleteDialog(item)">
                <v-list-item-title class="red--text">Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
      <v-card-actions>
        <pagination-component
          :links="batches?.meta?.links"
          @goto="go_to_page"
        ></pagination-component>
      </v-card-actions>
    </v-card>

    <BatchDetailsDialog
      :detailsOpen="detailsOpen"
      @detailsClosed="detailsOpen = false"
      :selected_batch="selected_batch"
    />
    <UpdateBatchDialog
      :updateDialogOpen="updateDialogOpen"
      @update_closed="updateDialogOpen = false"
      @update_completed="
        get_batches();
        updateDialogOpen = false;
      "
      :selected_batch="selected_batch"
    />
    <DeleteBatchDialog
      :deleteDialogOpen="deleteDialogOpen"
      @delete_closed="deleteDialogOpen = false"
      @delete_completed="get_batches()"
      :selected_batch="selected_batch"
    />
  </span>
</template>

<script>
import BatchDetailsDialog from "./BatchDetailsDialog.vue";
import UpdateBatchDialog from "./UpdateBatchDialog.vue";
import DeleteBatchDialog from "./DeleteBatchDialog.vue";
import PaginationComponent from "../PaginationComponent.vue";

export default {
  components: {
    BatchDetailsDialog,
    UpdateBatchDialog,
    DeleteBatchDialog,
    PaginationComponent,
  },
  props: ["batch_response", "getting_batches", "data_name"],
  data() {
    return {
      name: "batchTable",
      headers: [
        { text: "Batch Number", value: "batch_number" },
        { text: "Product", value: "item.id" },
        { text: "Expiry Date", value: "expiry_date" },
        { text: "Quantity", value: "quantity" },
        { text: "Status", value: "status" },
        { text: "Created At", value: "created_at" },
        { text: "Update At", value: "updated_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      batches: null,
      detailsOpen: false,
      updateDialogOpen: false,
      deleteDialogOpen: false,
      selected_batch: null,
      loading: false,
    };
  },

  watch: {
    batch_response: {
      immediate: true,
      handler(newValue) {
        this.batches = newValue;
      },
    },
    getting_batches(newValue) {
      this.loading = newValue;
    },
  },
  methods: {
    get_batches() {
      this.loading = true;
      axios.get("/api/item-batches").then((response) => {
        this.batches = response.data;
        this.loading = false;
      });
    },
    openDetailsDialog(item) {
      this.selected_batch = item;
      this.detailsOpen = true;
    },
    openUpdateDialog(item) {
      this.selected_batch = item;
      this.updateDialogOpen = true;
    },
    openDeleteDialog(item) {
      this.selected_batch = item;
      this.deleteDialogOpen = true;
    },

    go_to_page(page) {
      this.loading = true;
      const params = new URLSearchParams();

      if (this.data_name !== "all") {
        params.append("status", this.data_name);
      }

      params.append("page", page);

      let url = `item-batches?${params.toString()}`;

      axios.get("/api/" + url).then((res) => {
        this.batches = res.data;
        this.loading = false;
      });
    },
    get_expiry_status(item) {
      if (item.status === "safe") {
        return {
          text: "Safe",
          textColor: "green--text",
          color: "green",
          bgColor: "green lighten-5",
          icon: "mdi-check-circle",
        };
      }

      if (item.status === "expired") {
        return {
          text: "Expired",
          textColor: "red--text",
          color: "red",
          bgColor: "red lighten-5",
          icon: "mdi-shield-remove-outline",
        };
      } else if (item.status === "expiring-soon") {
        return {
          text: "Expiring Soon",
          color: "orange",
          icon: "mdi-shield-half",
          bgColor: "orange lighten-5",
          textColor: "orange--text",
        };
      }

      return {
        text: "Safe",
        textColor: "green--text",
        bgColor: "green lighten-5",
        color: "green",
        icon: "mdi-shield-check",
      };
    },
  },
  computed: {
    item_id() {
      return this.$route.params.id;
    },

    inventory_batch_settings() {
      return this.$store.state.user.current_business.inventory_batch_setting;
    },
  },
  mounted() {
    if (this.item_id) {
      this.get_batches();
    }
  },
};
</script>
